import * as React from "react";
import { Container, Grid, Typography, makeStyles } from "@material-ui/core";
import { Fade } from "react-awesome-reveal";
import Image from "next/image";
import CurrencyFormat from "../../../../../services/CurrencyFormat";

import a from "../../../../../public/assets/images/op/01.png";
import b from "../../../../../public/assets/images/op/02.png";
import c from "../../../../../public/assets/images/op/03.png";
import d from "../../../../../public/assets/images/op/04.png";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 30,

    padding: "10px",

    borderRadius: "10px",
    background: "#FFF",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
    // boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
  },
  image: {
    borderRadius: "5px",
  },
  imageParent: {
    boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
    padding: 10,

    borderRadius: "100%",
    width: 60,
    [theme.breakpoints.down("lg")]: {
      width: 50,
    },
    [theme.breakpoints.down("md")]: {
      width: 45,
    },
    [theme.breakpoints.down("sm")]: {
      width: 35,
    },
    [theme.breakpoints.down("xs")]: {
      width: 40,
    },
  },
  grids: {
    padding: 6,
  },
  t1: {
    fontSize: "18px",
    color: "#009693",
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  t2: {
    fontSize: "18px",
    color: "#292929",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  rial: {
    fontSize: "14px",
    [theme.breakpoints.down("md")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
}));

const Stats = ({ statistics = {} }) => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Grid container>
        {/* 1 */}
        <Grid item xs={6} md={3}>
          <Grid container alignItems="center">
            <Grid item className={classes.grids} xs={12} sm={2} md={3}>
              <div className={classes.imageParent}>
                <Image
                  src={a}
                  placeholder="blur"
                  alt="تعداد حامی"
                  width={60}
                  height={55}
                  className={classes.image}
                  layout="responsive"
                />
              </div>
            </Grid>
            <Grid item className={classes.grids} xs={12} sm={10} md={9}>
              <Typography variant="h5" className={classes.t1}>
                {CurrencyFormat(statistics.supporters_count || 0)}
              </Typography>
              <Typography variant="h5" className={classes.t2}>
                تعداد حامی
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* 2 */}
        <Grid item xs={6} md={3}>
          <Grid container alignItems="center">
            <Grid item className={classes.grids} xs={12} sm={2} md={3}>
              <div className={classes.imageParent}>
                <Image
                  src={b}
                  placeholder="blur"
                  alt="تعداد مددجو"
                  width={60}
                  height={55}
                  className={classes.image}
                  layout="responsive"
                />
              </div>
            </Grid>
            <Grid item className={classes.grids} xs={12} sm={10} md={9}>
              <Typography variant="h5" className={classes.t1}>
                {CurrencyFormat(statistics.needful_count || 0)}
              </Typography>
              <Typography variant="h5" className={classes.t2}>
                تعداد مددجو
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* 3 */}
        <Grid item xs={6} md={3}>
          <Grid container alignItems="center">
            <Grid item className={classes.grids} xs={12} sm={2} md={3}>
              <div className={classes.imageParent}>
                <Image
                  src={c}
                  placeholder="blur"
                  alt="تعداد کارمندان"
                  width={60}
                  height={55}
                  className={classes.image}
                  layout="responsive"
                />
              </div>
            </Grid>
            <Grid item className={classes.grids} xs={12} sm={10} md={9}>
              <Typography variant="h5" className={classes.t1}>
                {CurrencyFormat(statistics.staff_count || 0)}
              </Typography>
              <Typography variant="h5" className={classes.t2}>
                تعداد کارمندان
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* 4 */}
        <Grid item xs={6} md={3}>
          <Grid container alignItems="center">
            <Grid item className={classes.grids} xs={12} sm={2} md={3}>
              <div className={classes.imageParent}>
                <Image
                  src={d}
                  placeholder="blur"
                  alt="تعداد داوطلبان"
                  width={60}
                  height={55}
                  className={classes.image}
                  layout="responsive"
                />
              </div>
            </Grid>
            <Grid item className={classes.grids} xs={12} sm={10} md={9}>
              <Typography variant="h5" className={classes.t1}>
                {CurrencyFormat(statistics.volunteers_count || 0)}
              </Typography>
              <Typography variant="h5" className={classes.t2}>
                تعداد داوطلبان
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Stats;
